import { render, staticRenderFns } from "./UnAuthen.vue?vue&type=template&id=388c8012"
import script from "./UnAuthen.vue?vue&type=script&lang=js"
export * from "./UnAuthen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports